<template>
    <div id="rule">
        <div class="rule-content flex">
            <div class="rule-box">
                <div>{{user.role}}：{{user.name}}</div>
                <div class="pdf-content" style="background: #ffffff">
                    <pdf
                            v-for="i in numPages"
                            :key="i"
                            :src="src"
                            :page="i"
                            class="pdf-set"
                            style="background: #ffffff"
                    ></pdf>
                </div>
            </div>
        </div>
        <div style="width: 100%;height: 100px;"></div>
        <div class="agree-box">
            <el-checkbox v-model="verifyRule" :label="true" :disabled="checkDisabled" @change="checkAgree"
                         style="margin-top: 20px;padding-left: 40px;">
                {{checkText}}
                <span v-if="countDown!=0" class="count-down"> 还剩 {{countDown}} s</span></el-checkbox>
            <el-button :disabled="btnCheck" @click="getVideoToken" class="agree-btn">加入网上开庭</el-button>
        </div>
    </div>
</template>

<script>
  import pdf from 'vue-pdf'
  import myHeader from '../../components/Header';
  import client from '../../utils/client';

  export default {
    components: {
      myHeader,
      pdf
    },
    name: 'rule',
    data() {
      return {
        verifyRule: false,
        countDown: 10,
        checkDisabled: true,
        timer: null,
        btnCheck: true,
        title: '',
        src:'',
        numPages: undefined,
        user: { role: sessionStorage.getItem('role'), name: sessionStorage.getItem('name') },
        checkText:'请仔细阅读上述协议内容'
      };
    },
    watch: {
      countDown(val, oldVal) {
        if (val == 0) {
          this.clearCountDown();
        }
      }
    },
    mounted() {
      if (sessionStorage.getItem('oId') && sessionStorage.getItem('phone')) {
        let oId = sessionStorage.getItem('oId')
        if(oId == 'demo'){
          this.countDown = 3
        }
        let fileName = `https://files.i-ac.cn/public/${oId}.PDF`
        this.src = pdf.createLoadingTask(fileName)
        console.log(fileName)
        this.src.then(pdf => {
          this.numPages = pdf.numPages;
        })
          .catch((err)=>{
            console.log('pdf文件出错！',fileName)
          })
      } else {
        this.$message.error('缺少参数，请检查链接！');
        this.goToPath('/error',{})
      }
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown -= 1;
        }
      }, 1000);
    },
    methods: {
      getVideoToken() {
        let caseId = sessionStorage.getItem('caseId');
        let kaitingId = sessionStorage.getItem('kaitingId');
        let phone = sessionStorage.getItem('phone');
        if (!caseId && !kaitingId && !phone) {
          this.goToPath('/error', {});
          this.$message.error('缺少参数!');
          // loadingInstance.close();
        }
        client
          .getVideoToken({ caseId: caseId, kaitingId: kaitingId, phone: phone })
          .then(res => {
            console.log(res);
            if (res.hasOwnProperty('token')) {
              sessionStorage.setItem('users', JSON.stringify(res.users));
              sessionStorage.setItem('token', res.token);
              sessionStorage.setItem('startTime',res.startTime)
              // loadingInstance.close();
              this.goToPath('/video');
            } else {
              this.$message.error('加入房间错误！');
            }
          })
          .catch(data => {
            // loadingInstance.close();
            console.log(data);
          });
      },
      clearCountDown() {
        this.checkText = '我已认真阅读并同意上述须知'
        this.checkDisabled = false;
        this.timer = null;
      },
      checkAgree() {
        this.btnCheck = !this.btnCheck;
      },
      logout(){
        this.goToPath('/home',{})
      },
      goToPath(path, query) {
        this.$router.push({
          path,
          query
        });
      }
    }

  };
</script>

<style lang="scss">
    @import '../../theme/variables';

    .pdf-set {
        width: 100%;
    }

    #rule {
        width: 100%;

        .rule-content {
            width: 100%;
            margin: 0 auto;
            flex-direction: column;
            overflow-y: scroll;

            .rule-box {
                width: 100%;
                background-color: #ffffff;
                box-shadow: 0px 0px 13px 0px rgba(2, 133, 226, 0.1);
                padding: 40px 20px;
                box-sizing: border-box;
            }

            h2 {
                font-size: 22px;
                color: #0285e2;
                margin: 0 auto;
                width: 100%;
                text-align: center;
                margin-bottom: 20px;
            }

            .pdf-content {
                width: 100%;
                /*height: 100vh;*/
                overflow-y: auto;
            }
        }

        .agree-box {
            position: fixed;
            bottom: 0;
            background-color: #ffffff;
            box-shadow: 0px 0px 13px 0px
            rgba(0, 0, 0, 0.11);
            display: flex;
            flex-direction: column;
            width: 100%;

            .el-checkbox:checked {

            }

            .el-checkbox {
                font-size: 16px;
                color: #333333;
            }

            .count-down {
                color: #0285e2;
            }

            .agree-btn:disabled {
                background-color: #cacaca;
            }

            .agree-btn {
                color: #ffffff;
                border-radius: unset;
                background-color: #0285e2;
                margin: 20px;
            }
        }
    }

    #Header {
        height: 60px;
        background: map-get($colors, primary);
        display: flex;
        align-items: center;
        padding: 0 30px;
        line-height: 80px;
        justify-content: space-between;
        color: #ffffff;

        .header-left {
            font-size: 20px;
        }

        .header-right {
            justify-content: flex-end;
            display: flex;
            height: 60px;
            align-items: center;
        }

        .index_exit_btn {
            width: 98px;
            height: 36px;
            border: 0;
            font-size: 20px;
            background: map-get($colors, primary-shade);
            text-align: center;
            margin-left: 60px;
        }


    }
</style>
